import { View } from "@dhx/ts-common/view";
import { create } from "@dhx/ts-common/dom";
import { IShadow } from "./types";

export class Shadow extends View implements IShadow {
	constructor(configurator) {
		super(document.body, null);
		const shadow = create({ render: () => configurator.getShadow() }, configurator);
		this.mount(document.body, shadow);
	}

	destructor() {
		this.unmount();
	}
}
